export const ID = 'id';
export const CALENDAR_URL = 'calendarUrl';

